import {ComponentConfig} from '@gongxigames/framework/core/types/systemComponentsTypes';

export function disabledComponentByDefault<C extends ComponentConfig>(config: C): C {
    class DisabledComponent extends config {
        public static isEnabled(): boolean {
            return false;
        }
    }

    return DisabledComponent;
}
